import { render } from "./GzOldList.vue?vue&type=template&id=5810451e&scoped=true"
import script from "./GzOldList.vue?vue&type=script&lang=js"
export * from "./GzOldList.vue?vue&type=script&lang=js"

import "./GzOldList.vue?vue&type=style&index=0&id=5810451e&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5810451e"]])

export default __exports__